import styled from 'styled-components';
import { handleTextFontSize, handleTextLineHeight } from './BaseText.helpers';
const BaseText = styled.p `
  margin: 0;
  padding: 0;
  letter-spacing: 0rem;
  font-weight: ${({ weight }) => weight || '400'};
  font-size: ${({ textSize }) => (textSize ? handleTextFontSize(textSize) : 'inherit')};
  line-height: ${({ textSize }) => (textSize ? handleTextLineHeight(textSize) : 'inherit')};
  color: ${({ $color, theme }) => $color || theme.colors.text01};
  ${({ uppercase }) => uppercase && 'text-transform: uppercase;'};
`;
export default BaseText;
//# sourceMappingURL=BaseText.js.map